import InventarioInicial from "./InventarioInicial";
export default InventarioInicial;
